module.exports = __webpack_public_path__ + "6325548d2e87b01e915fbc2e6bc5063d.MP3";